export class UserBegleitIndikator {
  indikatoren!: String[];
}
